/* eslint-disable no-console */
import { captureMessage } from '@sentry/browser'
import { VIDEO_MEDIA_ERROR_CODES } from './const'

/**
 * Tracking some errors Safari mobile seems to have
 * with some videos.
 * Currently, this method is used with the
 * onError() callback of ReactPlayer
 * @param {Object} event - the error event from the HTML5 <video/> element
 * @param {string} videoUrl - the url of the video, for monitoring purposes
 */
const handleVideoErrors = (event, videoUrl) => {
  const videoError = event?.srcElement?.error

  if (videoError) {
    const { code } = videoError
    const error = {
      code,
      message: VIDEO_MEDIA_ERROR_CODES[code],
    }

    const errorMessage = `Code: ${error.code || 'NULL'}`
    const errorCode = `Message: ${error.message || 'NULL'}`
    const errorExtended = `Unable to play video: ${errorMessage}, ${errorCode}`

    console.error(errorExtended)
    console.error(`Error Loading Video: ${videoUrl}`)

    captureMessage(errorExtended)
  }
}

export default handleVideoErrors
